import React from 'react'
import { Slot } from 'radix-ui'

import { ampli } from '@/shared/lib/ampli'
import { useModals } from '@/shared/lib/modal-manager'

export const CopyPricingCampaignSettings = ({
	pricingCampaignId,
	onDone,
	children,
}: {
	onDone?: () => void
	pricingCampaignId: string
	children: React.ReactNode
}) => {
	const { showModal } = useModals()
	const handleDublicatePricingCampaignsClick = () => {
		ampli.settingsPricingCampaignsTableDuplicatePCs()
		showModal('COPY_PRICING_CAMPAIGN_SETTINGS', {
			selected: pricingCampaignId,
			resetSelectedItems: onDone,
		})
	}

	return (
		<Slot.Root onClick={handleDublicatePricingCampaignsClick}>
			{children}
		</Slot.Root>
	)
}
